import { render, staticRenderFns } from "./RemediationActionReport.vue?vue&type=template&id=50181311"
import script from "./RemediationActionReport.vue?vue&type=script&lang=js"
export * from "./RemediationActionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports